import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/WorkAssign.css";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { doctorList, employeeList, getRegionalManagerApi, workAssignApi } from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const WorkAssignEmployee = () => {
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [employee, setEmployee] = useState([]);
  const [formData, setFormData] = useState({
    workTitle: "",
    workDescription: "",
    employeeIds: [],
    assignedDate: "",
  });

  useEffect(() => {
    const fetchEmployeeList = async () => {
      try {
        const response = await employeeList(token);
        console.log("response : ", response);
        setEmployee(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchEmployeeList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEmployeeChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setFormData((prev) => ({
      ...prev,
      employeeIds: [selectedId],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { workTitle, workDescription, assignedDate, employeeIds } = formData;

    console.log("employeeIds : ",employeeIds)

    if (
      !workTitle ||
      !workDescription ||
      !assignedDate ||
      employeeIds.length === 0
    ) {
      alert("Please fill all fields");
      return;
    }

    try {
      const response = await workAssignApi(formData, token);
      console.log("Work Assign Response:", response.data);
      if(response.status === 200){
        toast.success("Work Assign added successfully");
      setFormData({
        workTitle: "",
        workDescription: "",
        employeeIds: [],
        assignedDate: "",
      });
    }
    } catch (error) {
      console.error("Error assigning work:", error);
      alert("Error assigning work.");
    } 
  };
  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="work-assign-container">
          <h2>Assign Work</h2>
          <form onSubmit={handleSubmit} className="work-form">
            <div className="form-group">
              <label>Work Title</label>
              <input
                type="text"
                name="workTitle"
                value={formData.workTitle}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Description</label>
              <textarea
                name="workDescription"
                value={formData.workDescription}
                onChange={handleChange}
                rows={3}
                required
              />
            </div>

            <div className="form-group">
              <label>Assign To Employee</label>
              <select onChange={handleEmployeeChange} required>
                <option value="">Select Employee</option>
                {employee.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.firstName}
                  </option>
                ))}
              </select>
            </div>

    

            <div className="form-group">
              <label>Assigned Date</label>
              <input
                type="date"
                name="assignedDate"
                value={formData.assignedDate}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="submit-btn">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WorkAssignEmployee;
